import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrappers,
  Label,
  SubmitBtn,
  SideCancelBtn,
  Wrapper,
  ScrollableContent,
  ActionSection,
  MobileIcon,
  ModalHeader,
  CombineInputGroup,
  ModalSubHeading,
  ModalHeading,
} from "./Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import DropZone from "./Notice/Dropzone";
import { useSelector } from "react-redux";
import axios from "axios";
import Config from "../Config";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import Loading from "../Components/Loading";


// Step 1 Validation Schema
const stepOneSchema = Yup.object().shape({
  businessName: Yup.string()
    .matches(
      /^[A-Za-z0-9. - ]+$/,
      "Only alphabets, numbers, spaces and hyphens are allowed"
    )
    .min(3, "Name must be at least 3 characters long")
    .required("Name is required"),
  businessEmail: Yup.string()
    .email("Enter a valid business email")
    .nullable(),
  gstNo: Yup.string().nullable(),
  panNo: Yup.string().nullable(),
  businessAddress: Yup.string().nullable(),
  bankName: Yup.string().nullable(),
  accountNo: Yup.string().nullable(),
  ifscCode: Yup.string().nullable(),
});

const stepTwoSchema = Yup.object().shape({
//   logo: Yup.mixed().required("Logo is required"),
  
});

const ProfileModal = ({
   handleClose 
}) => {
  const user = useSelector((state) => state.UserReducer.user);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    businessName: "",
    businessEmail: "",
    gstNo: "",
    businessAddress: "",
    panNo: "",
    bankName: "",
    accountNo: "",
    ifscCode: "",
    logo: null,
    signature: null,
  });

  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  //--Fetch the Company Details-----------------------------------------------
  const getProfileFunction = async () => {
    const response = await axios.get(
        `${Config.apiUrl}/user/profile`,
        {
        headers: {
            authorization: `Bearer ${user.token}`,
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        }
    );

    return response.data;
    };

    const getProfileSuccess = (res) => {
    if (res.isSuccess) {
        setFormData({
        businessName: res.user.businessName || "",
        businessEmail: res.user.businessEmail || "",
        gstNo: res.user.gstNo || "",
        businessAddress: res.user.businessAddress || "",
        panNo: res.user.panNo || "",
        bankName: res.user.bankName || "",
        accountNo: res.user.accountNo || "",
        ifscCode: res.user.ifscCode || "",
        logo: res.user.logo || null,
        signature: res.user.signImg || null,
        });
    }
    };

    const getProfileError = (err) => {
        toast.error(err?.response?.data?.msg || "Something went wrong");
    };

    const {
        mutate: getProfileMutate,
        isLoading: getProfileLoading,
        } = useMutation(getProfileFunction, {
        onSuccess: getProfileSuccess,
        onError: getProfileError,
    });

    useEffect(() => {
        getProfileMutate();
    }, []);

//------------Update Profile Details----------
    const updateProfileFunction = async (values) => {
    return await axios.post(
        `${Config.apiUrl}/user/editProfile`,
        values,
        {
        headers: {
            authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data",
        },
        }
    );
    };

    const updateProfileSuccess = (res) => {
    if (res.data.isSuccess) {
        toast.success(res.data.msg);

        getProfileMutate(); // refresh latest data

        handleClose();
    } else {
        toast.error(res.data.msg);
    }
    };

    const updateProfileError = (err) => {
    toast.error(err?.response?.data?.msg || "Something went wrong");
    };

    const {
    mutate: updateProfileMutate,
    isLoading: updateProfileLoading,
    } = useMutation(updateProfileFunction, {
    onSuccess: updateProfileSuccess,
    onError: updateProfileError,
    });

  const handleSubmit = (values) => {
    const formData = new FormData();

    formData.append("businessName", values.businessName);
    formData.append("businessEmail", values.businessEmail || "");
    formData.append("gstNo", values.gstNo || "");
    formData.append("businessAddress", values.businessAddress || "");
    formData.append("panNo", values.panNo || "");
    formData.append("bankName", values.bankName || "");
    formData.append("accountNo", values.accountNo || "");
    formData.append("ifscCode", values.ifscCode || "");
    
    if (values.logo?.length > 0) {
    formData.append("logo", values.logo[0]);
    } else {
    formData.append("logo", "");
    }

    if (values.signature?.length > 0) {
      formData.append("signImg", values.signature[0]);
    } else {
      formData.append("signImg", "");
    }

    updateProfileMutate(formData);
  };

  const StepOneForm = () => (
  <Formik
    initialValues={formData}
    enableReinitialize
    validationSchema={stepOneSchema}
    onSubmit={(values) => {
      setFormData((prev) => ({
        ...prev,
        ...values,
      }));

      setCurrentStep(2);
    }}
  >
    {({ values, errors, touched, setFieldValue }) => (
      <Form>
        <ModalSubHeading>Step 1</ModalSubHeading>
        <ModalHeading>Business & Financial Details</ModalHeading>

        <ScrollableContent className="max-h-[calc(100dvh-180px)]">
          <Wrapper>

            <InputGroup>
              <Label>Company / Firm Name *</Label>
              <FieldWrappers>
                <Field
                  name="businessName"
                  placeholder="Enter company/firm name"
                  autoComplete="off"
                />
              </FieldWrappers>
              {errors.businessName && touched.businessName && (
                <ErrorMessage>{errors.businessName}</ErrorMessage>
              )}
            </InputGroup>
            <InputGroup>
              <Label>Business Email</Label>
              <FieldWrappers>
                <Field
                  type="email"
                  name="businessEmail"
                  placeholder="Enter business email"
                  autoComplete="off"
                  value={values.businessEmail}
                  onChange={(e) => {
                    const value = e.target.value.trim();

                    if (/^[A-Za-z0-9._%+-]*@?[A-Za-z0-9.-]*\.?[A-Za-z]{0,}$/.test(value)) {
                      setFieldValue("businessEmail", value);
                    }
                  }}
                />
              </FieldWrappers>
              {errors.businessEmail && touched.businessEmail && (
                <ErrorMessage>{errors.businessEmail}</ErrorMessage>
              )}
            </InputGroup>

            <CombineInputGroup>
              <InputGroup>
                <Label>GST Number</Label>
                <FieldWrappers>
                  <Field
                    name="gstNo"
                    placeholder="Enter gst number"
                    autoComplete="off"
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase();

                      if (/^[A-Z0-9]*$/.test(value) && value.length <= 15) {
                          setFieldValue("gstNo", value);
                      }
                      }}
                  />
                </FieldWrappers>
              </InputGroup>

              <InputGroup>
                <Label>PAN Number</Label>
                <FieldWrappers>
                  <Field
                    name="panNo"
                    placeholder="Enter pan number"
                    value={values.panNo}
                    autoComplete="off"
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase();

                      if (/^[A-Z0-9]*$/.test(value) && value.length <= 10) {
                      setFieldValue("panNo", value);
                      }
                  }}
                  />
                </FieldWrappers>
              </InputGroup>
            </CombineInputGroup>

            <InputGroup>
              <Label>Bank Name</Label>
              <FieldWrappers>
                <Field
                  name="bankName"
                  placeholder="Enter bank name"
                  autoComplete="off"
                />
              </FieldWrappers>
            </InputGroup>

           <CombineInputGroup>
                <InputGroup>
                    <Label>Account Number</Label>
                    <FieldWrappers>
                        <Field
                            name="accountNo"
                            placeholder="Enter account number"
                            value={values.accountNo}
                            onChange={(e) => {
                                const value = e.target.value;

                                if (/^\d*$/.test(value) && value.length <= 18) {
                                setFieldValue("accountNo", value);
                                }
                            }}
                            autoComplete="off"
                        />
                    </FieldWrappers>
                    </InputGroup>

                    <InputGroup>
                    <Label>IFSC Code</Label>
                    <FieldWrappers>
                        <Field
                            name="ifscCode"
                            placeholder="Enter ifsc code"
                            value={values.ifscCode}
                            onChange={(e) => {
                                const value = e.target.value.toUpperCase();

                                if (/^[A-Z0-9]*$/.test(value) && value.length <= 11) {
                                setFieldValue("ifscCode", value);
                                }
                            }}
                            autoComplete="off"
                        />
                    </FieldWrappers>
                </InputGroup>
           </CombineInputGroup>

            <InputGroup>
              <Label>Business Address</Label>
              <Field
                as={Textarea}
                name="businessAddress"
                rows={4}
                placeholder="Enter address"
                onChange={(e) => {
                  const value = e.target.value;

                  if (value.length <= 145) {
                    setFieldValue("businessAddress", value);
                  }
                }}
              />
            </InputGroup>

          </Wrapper>
        </ScrollableContent>

        <ActionSection>
          <SideCancelBtn
            type="button"
            onClick={handleClose}
          >
            Cancel
          </SideCancelBtn>

          <SubmitBtn type="submit">
            Next
          </SubmitBtn>
        </ActionSection>
      </Form>
    )}
  </Formik>
);

const StepTwoForm = () => (
  <Formik
     initialValues={{
    logo: formData.logo,
    signature: formData.signature,
  }}
    enableReinitialize
    validationSchema={stepTwoSchema}
    onSubmit={(values) => {
      const finalValues = {
        ...formData,
        ...values,
      };

      handleSubmit(finalValues);
    }}
  >
    {({ errors, touched, values, setFieldValue }) => (
      <Form>

        <ModalSubHeading>Step 2</ModalSubHeading>
        <ModalHeading>Brand Identity</ModalHeading>

        <ScrollableContent className="max-h-[calc(100dvh-180px)]">
          <Wrapper>

            <InputGroup>
              <Label>Upload Logo</Label>

              <Field name="logo">
                {(props) => (
                  <DropZone
                    componentFor="logo"
                    setFieldValue={props.form.setFieldValue}
                    initialFile={formData.logo}
                  />
                )}
              </Field>
            </InputGroup>

            <InputGroup>
              <Label>Upload Signature</Label>

              <Field name="signature">
                {(props) => (
                  <DropZone
                    componentFor="signature"
                    setFieldValue={props.form.setFieldValue}
                    initialFile={formData.signature}
                  />
                )}
              </Field>
            </InputGroup>

          </Wrapper>
        </ScrollableContent>

        <ActionSection>

          <SideCancelBtn
            type="button"
            onClick={() => setCurrentStep(1)}
          >
            Back
          </SideCancelBtn>

          <SubmitBtn
            type="submit"
            disabled={updateProfileLoading}
          >
            {updateProfileLoading ? "Updating..." : "Update"}
          </SubmitBtn>

        </ActionSection>

      </Form>
    )}
  </Formik>
);


  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <ModalHeader>
        <Title>{"Company Details"}</Title>
        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>

        {getProfileLoading ? (
      <Loading />
    ) : (
      <div className="px-6 h-full flex flex-col justify-between">
            {currentStep === 1 && (
                <StepOneForm
                    formData={formData}
                    setFormData={setFormData}
                    setCurrentStep={setCurrentStep}
                    handleClose={handleClose}
                />
            )}

            {currentStep === 2 && (
                <StepTwoForm
                    formData={formData}
                    handleSubmit={handleSubmit}
                    setCurrentStep={setCurrentStep}
                    updateProfileLoading={updateProfileLoading}
                />
            )}
        </div>
        )}
    </Container>
  );
};

{/* <div className="px-6 h-full flex flex-col justify-between">
            {currentStep === 1 && (
                <StepOneForm
                    formData={formData}
                    setFormData={setFormData}
                    setCurrentStep={setCurrentStep}
                    handleClose={handleClose}
                />
            )}

            {currentStep === 2 && (
                <StepTwoForm
                    formData={formData}
                    handleSubmit={handleSubmit}
                    setCurrentStep={setCurrentStep}
                    updateProfileLoading={updateProfileLoading}
                />
            )}
        </div> */}

// Styled components
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Title = tw.h1`text-white text-lg font-medium`;
const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
const Textarea = tw.textarea`min-h-30 border border-gray-300 rounded pl-2 py-2  focus:outline-none duration-200 w-full h-30 resize-y  break-words overflow-hidden`;

export default ProfileModal;